export * from './ngx-inactivity.module';



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/~/ngx-inactivity/src/app/ngx-inactivity/index.ts